import { RouteObject } from "react-router-dom";
import ProtectedOutlet from "components/ProtectedOutlet";
import { ClaimResource } from "types/claimTypes";

import OrganizationList from "pages/OrganizationsPage/OrganizationList";
import OrganizationDetails from "pages/OrganizationsPage/OrganizationDetails";
import OrganizationCreateForm from "pages/OrganizationsPage/OrganizationCreateForm";

import DynamicMenuPage from "pages/DynamicMenuPage";
import MenuList from "pages/DynamicMenuPage/MenusPage/MenuList";
import MenuDetails from "pages/DynamicMenuPage/MenusPage/MenuDetails";
import MenuCreateForm from "pages/DynamicMenuPage/MenusPage/MenuCreateForm";
import MenuUpdateForm from "pages/DynamicMenuPage/MenusPage/MenuUpdateForm";
import MenuItemList from "pages/DynamicMenuPage/MenuItemsPage/MenuItemList";
import MenuItemDetails from "pages/DynamicMenuPage/MenuItemsPage/MenuItemDetails";
import MenuItemCreateForm from "pages/DynamicMenuPage/MenuItemsPage/MenuItemCreateForm";
import MenuItemUpdateForm from "pages/DynamicMenuPage/MenuItemsPage/MenuItemUpdateForm";

import ContentTemplateList from "pages/ContentTemplatesPage/ContentTemplateList";
import ContentTemplateDetails from "pages/ContentTemplatesPage/ContentTemplateDetails";
import ContentTemplateForm from "pages/ContentTemplatesPage/ContentTemplateForm";

import RolesList from "pages/RolesPage/RolesList";
import RoleDetails from "pages/RolesPage/RoleDetails";
import CreateRole from "pages/RolesPage/CreateRole";
import UpdateRole from "pages/RolesPage/UpdateRole";

import RegexValidations from "pages/RegexValidations/RegexValidations";
import SkuFormats from "pages/SkuFormats/SkuFormats";

import WizardList from "pages/WizardsPage/WizardList";
import WizardDetails from "pages/WizardsPage/WizardDetails";
import WizardCreateForm from "pages/WizardsPage/WizardCreateForm";

import SettingsList from "pages/SettingsPage/SettingsList";
import SettingDetails from "pages/SettingsPage/SettingDetails";

import ReprocessCompletionsPage from "pages/ReprocessCompletionsPage";

import { ContentBlockList } from "pages/ContentBlocksPage/ContentBlockList";
import { ContentBlockDetails } from "pages/ContentBlocksPage/ContentBlockDetails";
import { ContentBlockCreateForm } from "pages/ContentBlocksPage/ContentBlockCreateForm";
import { ContentBlockUpdateForm } from "pages/ContentBlocksPage/ContentBlockUpdateForm";

import ConfigurationPage from "pages/ConfigurationPage";

export const configurationRoutes: RouteObject[] = [
  {
    element: <ProtectedOutlet claims={[ClaimResource.Organizations]} />,
    children: [
      { path: "organizations", element: <OrganizationList /> },
      { path: "organizations/new", element: <OrganizationCreateForm /> },
      { path: "organizations/-/:organizationId", element: <OrganizationDetails /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.DynamicMenu]} />,
    children: [
      { path: "dynamic-menu", element: <DynamicMenuPage /> },
      { path: "dynamic-menu/menus", element: <MenuList /> },
      { path: "dynamic-menu/menus/new", element: <MenuCreateForm /> },
      { path: "dynamic-menu/menus/-/:id", element: <MenuDetails /> },
      { path: "dynamic-menu/menus/edit/:id", element: <MenuUpdateForm /> },
      { path: "dynamic-menu/menu-items", element: <MenuItemList /> },
      { path: "dynamic-menu/menu-items/new", element: <MenuItemCreateForm /> },
      { path: "dynamic-menu/menu-items/-/:id", element: <MenuItemDetails /> },
      { path: "dynamic-menu/menu-items/edit/:id", element: <MenuItemUpdateForm /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.ContentTemplates]} />,
    children: [
      { path: "templates", element: <ContentTemplateList /> },
      { path: "templates/new", element: <ContentTemplateForm /> },
      { path: "templates/-/:id", element: <ContentTemplateDetails /> },
      { path: "templates/edit/:id", element: <ContentTemplateForm /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.Roles]} />,
    children: [
      { path: "roles", element: <RolesList /> },
      { path: "roles/new", element: <CreateRole /> },
      { path: "roles/-/:id", element: <RoleDetails /> },
      { path: "roles/edit/:id", element: <UpdateRole /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.SkuFormats]} />,
    children: [{ path: "sku-formats", element: <SkuFormats /> }],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.RegexValidations]} />,
    children: [{ path: "regex-validations", element: <RegexValidations /> }],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.Wizards]} />,
    children: [
      { path: "wizards", element: <WizardList /> },
      { path: "wizards/new", element: <WizardCreateForm /> },
      { path: "wizards/:id", element: <WizardDetails /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.Settings]} />,
    children: [
      { path: "settings", element: <SettingsList /> },
      { path: "settings/-/:id", element: <SettingDetails /> },
      { path: "reprocess-completions", element: <ReprocessCompletionsPage /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.ContentBlocks]} />,
    children: [
      { path: "content-blocks", element: <ContentBlockList /> },
      { path: "content-blocks/create", element: <ContentBlockCreateForm /> },
      { path: "content-blocks/-/:id", element: <ContentBlockDetails /> },
      { path: "content-blocks/edit/:id", element: <ContentBlockUpdateForm /> },
    ],
  },
  { index: true, element: <ConfigurationPage /> },
];
